<div class="registration">
  <div class="pt-2 pb-2">
    <form [formGroup]="registrationForm" novalidate (ngSubmit)="onSubmit()">
      <mat-card class="_registration-card"
                [ngClass.xs]="'w-mobile'"
                [ngClass.gt-xs]="'w-desktop'">
        <h4>Registration</h4>

        <mat-card-content>
          <div class="row">
            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <input matInput
                       type="email"
                       placeholder="Email"
                       formControlName="email"
                       required />
                <mat-error *ngIf="isEmailNotValid()">
                  {{ getEmailErrorMessage() }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row position-relative">
            <div class="col-sm-12"
                 fxLayout="column"
                 fxLayoutAlign="center center"
                 fxLayoutGap="5px"  *ngIf="enablePhoneRegConfirm">
              <div class="divider-caption theme-text-accent text-center font-weight-bold" style="letter-spacing: -0.01em;">
                For protection of our members and to curb spam we need to verify you're a real person
                <div>We will send you a one time code to your phone number</div>
              </div>
              <div style="margin-top: 10px;"><img src="assets/img/icons/mobile_icon.png" /></div>
            </div>

            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <input matInput
                       type="tel"
                       placeholder="Phone"
                       formControlName="phone"
                       required />
                <mat-error *ngIf="
                    registrationForm.controls['phone'].hasError('required')
                  ">
                  Phone is required
                </mat-error>
              </mat-form-field>
              <div class="w-100 p-3 text-center" style="color: #000">
                <span class="font-size-12p font-weight-bold">
                  We take your privacy very seriously. We don't use or disclose
                  your phone number
                </span><br />
                <span class="font-size-12p">
                  This number will be associated with this email address. You
                  won't be able to use it twice to register another email
                  account
                </span>
              </div>
            </div>
            <div class="col-sm-12 pb-2">
              <mat-divider [inset]="true"></mat-divider>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <input matInput
                       #password
                       type="password"
                       placeholder="Password"
                       formControlName="password"
                       required />
                <mat-error *ngIf="isPasswordNotValid()">
                  {{ getPasswordErrorMessage() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <input matInput
                       #passwordConfirm
                       type="password"
                       placeholder="Password Confirmation"
                       formControlName="passwordConfirm"
                       required />
                <mat-error>
                  {{ getPasswordConfirmErrorMessage() }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-1">
            <div class="col-sm-12">
              <div class="disclaimer p-2">
                <b>Adult content disclaimer</b><br>
                This website may contain nudity, adult language and explicit
                sexual content. It should be accessed only by adults over the age
                of 18 (or the age of consent in the jurisdiction from which it is
                being accessed). By accessing this website, you identify that you
                are of legal age. Any unauthorized use of this site may violate
                state, federal and/or foreign law. By clicking I AGREE, you are
                making the following statements:
                <ul>
                  <li>
                    I understand and agree to abide by the standards and laws of
                    my community.
                  </li>
                  <li>
                    I am at least 18 years of age, and I have the legal right to
                    possess adult material in my community.
                  </li>
                  <li>
                    I will not post any language or materials that discriminate
                    based on race, color, religion, sex or national origin.
                  </li>
                  <li>
                    By viewing any part of this website, I agree that I shall not
                    hold the owners of the website or its employees responsible
                    for any materials located on the site.
                  </li>
                  <li>
                    The opinions expressed on this website are solely those of the
                    advertisers. They do not purport to reflect the opinions or
                    views of wickedlist.com or any of its' employees.
                  </li>
                  <li>
                    We will send you verification code via SMS to your mobile phone.
                  </li>
                </ul>
              </div>
              <div class="pt-2">
                <mat-checkbox formControlName="igreeDisclaimer">I Agree</mat-checkbox>
                <mat-error *ngIf="!formControlIsValid(registrationForm, 'igreeDisclaimer')">
                  Required
                </mat-error>

              </div>
              <div class="registration__captcha d-flex justify-content-lg-center mt-2">
                <re-captcha (resolved)="captchaResolved($event)" *ngIf="this.captchaAvailable()"
                            [siteKey]="this.services.captchaService.getCurrentCaptchaKey()"> </re-captcha>
              </div>   

            </div>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <div class="registration__loader" *ngIf="loading"><mat-spinner diameter="60" ></mat-spinner></div>
          <button class="full-width m-0"
                  type="submit"
                  mat-raised-button 
                  color="primary"
                  [disabled]="loading">
            Submit
          </button>
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
</div>
